import gql from "graphql-tag";

const chatGroupAuxQuery = gql`
    query ChatGroupAuxQuery($chatGroupId: String) {
        chatGroupAux(chatGroupId: $chatGroupId) {
            id
            willReply {
                dismissed
                mobileAdded
                created
            }
            labels {
                id
                name
            }
        }
        chatGroupLabels {
            id
            name
        }
    }
`;

export default chatGroupAuxQuery;
